<template>
  <div class="min-h-screen bg-gray-100 flex flex-col">
    <header class="animated-header text-white py-4">
      
      <div class="container mx-auto flex items-center justify-between px-8">
        <!-- Логотип -->
        <div class="flex justify-center items-center gap-4">
          <svg width="160" height="60" viewBox="0 0 160 60" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_1601_7)">
                    <path d="M17.9894 37.062V55.8188C17.9894 56.959 19.2377 57.6669 20.2158 57.0779L35.8005 47.7022C36.7516 47.1294 36.7516 45.7514 35.8005 45.1786L20.2158 35.8029C19.2377 35.2139 17.9894 35.9218 17.9894 37.062ZM17.9894 1.4885V20.2399C17.9894 21.3801 19.2377 22.088 20.2158 21.4989L35.8005 12.1233C36.7516 11.5505 36.7516 10.1725 35.8005 9.59968L20.2158 0.224002C19.2377 -0.365017 17.9894 0.342887 17.9894 1.4885ZM0 19.278V38.0293C0 39.1749 1.24829 39.8774 2.22639 39.2884L17.8111 29.9127C18.7622 29.3399 18.7622 27.9674 17.8111 27.3945L2.22639 18.0189C1.24829 17.4299 0 18.1324 0 19.278ZM35.9734 19.278V38.0293C35.9734 39.1749 37.2217 39.8774 38.2052 39.2884L53.7899 29.9127C54.741 29.3399 54.741 27.9674 53.7899 27.3945L38.2052 18.0189C37.2217 17.4299 35.9734 18.1324 35.9734 19.278Z" fill="#CF4520"></path>
                    <path class="logo_text" d="M74.1625 18.8673C74.611 18.4566 74.8325 17.8676 74.8325 17.111C74.8325 16.3383 74.611 15.7438 74.1625 15.3332C73.7139 14.9225 73.0601 14.7117 72.2009 14.7117H69.8664V19.4833H72.2009C73.0601 19.4833 73.7139 19.278 74.1625 18.8673ZM75.2162 12.7285C76.0214 13.1392 76.6428 13.712 77.0805 14.4577C77.5129 15.2035 77.7344 16.0897 77.7344 17.111C77.7344 18.1161 77.5129 18.997 77.0805 19.7535C76.6428 20.5046 76.0214 21.0774 75.2162 21.4773C74.4056 21.8772 73.4546 22.0772 72.3576 22.0772H69.8664V25.8653H67.0024V12.1233H72.3576C73.4546 12.1233 74.4056 12.3232 75.2162 12.7285ZM86.9156 20.5046L84.954 15.2467L82.9924 20.5046H86.9156ZM87.818 22.9202H82.0737L80.9767 25.8653H78.0424L83.5598 12.1233H86.386L91.9141 25.8653H88.9096L87.818 22.9202ZM99.7011 23.5092C100.436 23.5092 100.993 23.3525 101.382 23.0282C101.771 22.7094 101.965 22.2393 101.965 21.6286C101.965 20.4236 101.214 19.8183 99.7011 19.8183H96.8424V23.5092H99.7011ZM93.9946 12.1233H103.981V14.6577H96.8424V17.4839H100.268C101.765 17.4839 102.906 17.8297 103.689 18.5214C104.473 19.2185 104.862 20.2182 104.862 21.526C104.862 22.9039 104.429 23.9685 103.554 24.7304C102.684 25.487 101.452 25.8653 99.8632 25.8653H93.9946V12.1233ZM115.356 22.8337C115.945 22.4608 116.404 21.9421 116.739 21.272C117.08 20.6073 117.247 19.8454 117.247 18.997C117.247 18.1432 117.08 17.3866 116.739 16.7165C116.404 16.0519 115.945 15.5277 115.356 15.1548C114.767 14.782 114.108 14.5982 113.373 14.5982C112.643 14.5982 111.984 14.782 111.395 15.1548C110.806 15.5277 110.347 16.0519 110.006 16.7165C109.671 17.3866 109.504 18.1432 109.504 18.997C109.504 19.8454 109.671 20.6073 110.006 21.272C110.347 21.9421 110.806 22.4608 111.395 22.8337C111.984 23.2066 112.643 23.3957 113.373 23.3957C114.108 23.3957 114.767 23.2066 115.356 22.8337ZM109.904 25.179C108.871 24.5629 108.066 23.7199 107.483 22.6392C106.899 21.5584 106.607 20.3425 106.607 18.997C106.607 17.646 106.899 16.4301 107.483 15.3548C108.066 14.274 108.871 13.4256 109.904 12.8096C110.936 12.1935 112.092 11.8855 113.373 11.8855C114.659 11.8855 115.815 12.1935 116.837 12.8096C117.863 13.4256 118.669 14.274 119.258 15.3548C119.852 16.4301 120.144 17.646 120.144 18.997C120.144 20.3425 119.852 21.5584 119.258 22.6392C118.669 23.7199 117.863 24.5629 116.837 25.179C115.815 25.795 114.659 26.103 113.373 26.103C112.092 26.103 110.936 25.795 109.904 25.179ZM132.065 14.7117H128.109V25.8653H125.278V14.7117H121.338V12.1233H132.065V14.7117ZM141.03 20.5046L139.068 15.2467L137.107 20.5046H141.03ZM141.932 22.9202H136.188L135.096 25.8653H132.162L137.674 12.1233H140.5L146.034 25.8653H143.029L141.932 22.9202ZM74.076 38.1806C74.5245 37.7645 74.7461 37.1809 74.7461 36.419C74.7461 35.6516 74.5245 35.0572 74.076 34.6465C73.6275 34.2358 72.9736 34.0251 72.1144 34.0251H69.7799V38.7967H72.1144C72.9736 38.7967 73.6275 38.5913 74.076 38.1806ZM75.1298 32.0419C75.9349 32.4471 76.5564 33.0254 76.9887 33.7711C77.4264 34.5168 77.6425 35.403 77.6425 36.419C77.6425 37.4295 77.4264 38.3103 76.9887 39.0614C76.5564 39.818 75.9349 40.3908 75.1298 40.7907C74.3192 41.1906 73.3681 41.3905 72.2711 41.3905H69.7799V45.1786H66.9159V31.4366H72.2711C73.3681 31.4366 74.3192 31.6366 75.1298 32.0419ZM88.3854 42.147C88.9744 41.7742 89.4338 41.25 89.7688 40.5853C90.1038 39.9153 90.2768 39.1587 90.2768 38.3049C90.2768 37.4565 90.1038 36.7 89.7688 36.0299C89.4338 35.3598 88.9744 34.841 88.3854 34.4682C87.7964 34.0953 87.1317 33.9062 86.4022 33.9062C85.6727 33.9062 85.0134 34.0953 84.4244 34.4682C83.8354 34.841 83.376 35.3598 83.0356 36.0299C82.7006 36.7 82.533 37.4565 82.533 38.3049C82.533 39.1587 82.7006 39.9153 83.0356 40.5853C83.376 41.25 83.8354 41.7742 84.4244 42.147C85.0134 42.5199 85.6727 42.7036 86.4022 42.7036C87.1317 42.7036 87.7964 42.5199 88.3854 42.147ZM82.9329 44.4923C81.9008 43.8763 81.0956 43.0279 80.512 41.9525C79.9284 40.8717 79.6366 39.6559 79.6366 38.3049C79.6366 36.9594 79.9284 35.7435 80.512 34.6627C81.0956 33.5819 81.9008 32.7389 82.9329 32.1229C83.9597 31.5069 85.1215 31.1989 86.4022 31.1989C87.6883 31.1989 88.8447 31.5069 89.8661 32.1229C90.8928 32.7389 91.698 33.5819 92.287 34.6627C92.876 35.7435 93.1732 36.9594 93.1732 38.3049C93.1732 39.6559 92.876 40.8717 92.287 41.9525C91.698 43.0279 90.8928 43.8763 89.8661 44.4923C88.8447 45.1084 87.6883 45.4164 86.4022 45.4164C85.1215 45.4164 83.9597 45.1084 82.9329 44.4923ZM98.5987 44.5031C97.5828 43.8925 96.783 43.0495 96.1994 41.9687C95.6158 40.8879 95.324 39.6667 95.324 38.3049C95.324 36.9485 95.6158 35.7273 96.1994 34.6465C96.783 33.5657 97.5828 32.7227 98.5987 32.1121C99.62 31.5015 100.766 31.1989 102.036 31.1989C103.111 31.1989 104.078 31.4096 104.943 31.8257C105.813 32.2472 106.537 32.847 107.126 33.636L105.289 35.5165C104.451 34.4466 103.414 33.9062 102.181 33.9062C101.414 33.9062 100.728 34.0953 100.128 34.4682C99.5282 34.841 99.058 35.3598 98.723 36.0299C98.3879 36.7 98.2204 37.4565 98.2204 38.3049C98.2204 39.1587 98.3879 39.9153 98.723 40.5853C99.058 41.25 99.5282 41.7742 100.128 42.147C100.728 42.5199 101.414 42.7036 102.181 42.7036C103.414 42.7036 104.451 42.1633 105.289 41.0771L107.126 42.963C106.537 43.7574 105.807 44.368 104.937 44.7895C104.062 45.2056 103.089 45.4164 102.019 45.4164C100.76 45.4164 99.62 45.1084 98.5987 44.5031ZM112.076 44.5031C111.06 43.8925 110.26 43.0495 109.677 41.9687C109.093 40.8879 108.801 39.6667 108.801 38.3049C108.801 36.9485 109.093 35.7273 109.677 34.6465C110.26 33.5657 111.06 32.7227 112.076 32.1121C113.097 31.5015 114.243 31.1989 115.513 31.1989C116.588 31.1989 117.555 31.4096 118.42 31.8257C119.29 32.2472 120.014 32.847 120.603 33.636L118.766 35.5165C117.928 34.4466 116.891 33.9062 115.659 33.9062C114.891 33.9062 114.205 34.0953 113.605 34.4682C113.005 34.841 112.535 35.3598 112.2 36.0299C111.865 36.7 111.698 37.4565 111.698 38.3049C111.698 39.1587 111.865 39.9153 112.2 40.5853C112.535 41.25 113.005 41.7742 113.605 42.147C114.205 42.5199 114.891 42.7036 115.659 42.7036C116.891 42.7036 117.928 42.1633 118.766 41.0771L120.603 42.963C120.014 43.7574 119.285 44.368 118.415 44.7895C117.539 45.2056 116.567 45.4164 115.497 45.4164C114.237 45.4164 113.097 45.1084 112.076 44.5031ZM123.267 31.4366H126.11V40.3908L132.016 31.4366H134.702V45.1786H131.876V36.246L125.969 45.1786H123.267V31.4366ZM138.566 31.4366H141.408V40.3908L147.314 31.4366H150V45.1786H147.169V36.246L141.268 45.1786H138.566V31.4366Z" fill="white"></path>
            </g>
          </svg>
          <h1 class="md:text-xl text-l font-bold uppercase leading-5 md:border-l-2 md:pl-6">PR-ассистент</h1>
        </div>
        <div class="flex justify-center items-center gap-4">
          <div class="flex items-center gap-1 hover:opacity-75 cursor-pointer" @click="showMetodrecModal = true">
            <span class="text-xs font-bold uppercase">Как написать пресс-релиз</span>
            <span class="material-symbols-outlined text-xl">description</span>
          </div>
          <div class="flex items-center gap-1 hover:opacity-75 cursor-pointer" @click="showInstructionsModal = true">
            <span class="text-xs uppercase font-bold">Инструкция</span>
            <span class="material-symbols-outlined text-xl">info</span>
          </div>
          <div class="flex items-center gap-1 hover:opacity-75 cursor-pointer">
            <a href="https://cznnew.ru/" class="text-xs font-bold uppercase">Вернуться на сайт</a>
            <span class="material-symbols-outlined text-xl">logout</span>
          </div>
        </div>
        
      </div>
    </header>  
  
    <main class="flex-grow flex items-center justify-center">
      <div class="container mx-auto flex gap-6 p-8 flex-wrap md:flex-nowrap transition-all duration-500 ease-in-out">
        
        <!-- Форма ввода -->
        <div
          :class="[
            'w-full md:max-w-screen min-h-screen bg-white p-10 shadow-lg overflow-auto custom-scrollbar transition-all duration-500 ease-in-out',
            recommendations.length > 0 ? 'w-full md:w-1/2' : 'w-full'
          ]"
        >
          <form @submit.prevent="showResult">
            <!-- Заголовок -->
            <div class="mb-6">
              <label class="block text-sm font-thin text-gray-700 mb-2 text-left flex justify-between items-center">
                <span class="flex items-center gap-1">
                  <span class="text-gray-400 text-sm">Заголовок</span>
                  <span class="material-symbols-outlined text-xl text-gray-300 cursor-pointer hover:text-orange-600" @click="showModal = true">info</span>
                </span>
                <span :class="getCounterColor(title.length, 20, 110) + ' text-sm px-2 py-1 rounded'"
                      :style="{ backgroundColor: getCounterColorWithOpacity(title.length, 20, 110, 0.25) + ' !important' }">
                    {{ title.length }}/110
                </span>
              </label>
              
              <div class="relative">
                <textarea
                  v-model="title"
                  @input="handleInput($event, 'title')"
                  :class="['md:text-3xl text-2xl font-bold w-full focus:outline-none resize-none overflow-hidden', 
                    title ? '' : 'border-b border-gray-300']"
                  placeholder="Введите заголовок"
                ></textarea>
              </div>
            </div>

            <!-- Лид -->
            <div class="mb-6">
              <label class="block text-sm font-thin text-gray-700 mb-2 text-left flex justify-between items-center">
                <span class="flex items-center gap-1">
                  <span class="text-gray-400 text-sm">Лид</span>
                  <span class="material-symbols-outlined text-xl text-gray-300 cursor-pointer hover:text-orange-600" @click="showModal = true">info</span>
                </span>        
                <span :class="getCounterColor(lead.length, 20, 400) + ' text-sm px-2 py-1 rounded'"
                      :style="{ backgroundColor: getCounterColorWithOpacity(lead.length, 20, 400, 0.25) + ' !important' }">
                    {{ lead.length }}/400
                </span>
              </label>
              
              <div class="relative">
                <textarea
                  v-model="lead"
                  @input="handleInput($event, 'lead')"
                  :class="['text-xl font-normal w-full focus:outline-none resize-none overflow-hidden', 
                    lead ? '' : 'border-b border-gray-300']"
                  placeholder="Введите лид"
                ></textarea>
              </div>
            </div>

            <!-- Основной текст -->
            <div class="mb-6">
              <label class="block text-sm font-thin text-gray-700 mb-2 text-left flex justify-between items-center">
                <span class="flex items-center gap-1">
                  <span class="text-gray-400 text-sm">Основной текст</span>
                  <span class="material-symbols-outlined text-xl text-gray-300 cursor-pointer hover:text-orange-600" @click="showModal = true">info</span>
                </span> 
                <span :class="getCounterColor(body.length, 100, 2000) + ' text-sm px-2 py-1 rounded'"
                      :style="{ backgroundColor: getCounterColorWithOpacity(body.length, 100, 2000, 0.25) + ' !important' }">
                    {{ body.length }}/2000
                </span>
              </label>
              
              <div class="relative">
                <textarea
                  v-model="body"
                  @input="autoResize($event)"
                  :class="['text-md font-normal w-full focus:outline-none resize-none overflow-hidden', 
                    body ? '' : 'border-b border-gray-300']"
                  placeholder="Введите основной текст"
                ></textarea>
              </div>
            </div>

            <button
              type="submit"
              class="relative p-4 rounded-lg text-white bg-gray-300 overflow-hidden hover:animate-pulse"
              :disabled="!isFormValid || isLoading"
            >
              <!-- Прогресс-бар -->
              <span
                class="absolute inset-0 transition-all duration-300"
                :style="{ 
                  width: formCompletionPercentage + '%', 
                  backgroundColor: isLoading ? '#cf4520' : '#e54d2a', /* Активный цвет */
                  opacity: formCompletionPercentage > 0 ? 1 : 0 /* Плавное появление */
                }"
              ></span>

              <!-- Текст и спиннер поверх прогресс-бара -->
              <span class="relative z-10 flex items-center gap-1">
                <div v-if="isLoading" class="loading-spinner h-5 w-5"></div>
                <span v-else
                  class="material-symbols-outlined"
                  :class="{ 'animate-bounce': formCompletionPercentage === 100 }">bolt</span>
                <span v-if="isLoading">Генерация...</span>
                <span v-else>AI-ассистент</span>
              </span>
            </button>
          </form>
        </div>

        <!-- Модальное окно -->
        <div
          v-if="showModal"
          class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50"
          @click.self="showModal = false"
        >
          <div class="bg-white w-11/12 max-w-lg p-8 shadow-lg animate-bounce-once">
            <h2 class="text-2xl font-semibold mb-4">Рекоменуемый объем</h2>
                <ul class="list-disc pl-6">
                  <li><strong>Заголовок</strong>: от 20 до 110 знаков с пробелами</li>
                  <li><strong>Лид</strong>: от 20 до 400 знаков с пробелами</li>
                  <li><strong>Основной текст</strong>: от 100 до 2000 знаков с пробелами</li>
                </ul>

            <div class="mt-6 text-right">
              <button
                @click="showModal = false"
                class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500"
              >
                Закрыть
              </button>
            </div>
          </div>
        </div>

        <!-- Модальное окно Инструкции -->
        <div v-if="showInstructionsModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50" @click.self="showInstructionsModal = false">
          <div class="bg-white w-11/12 max-w-3xl p-8 shadow-lg overflow-y-auto max-h-[90vh]">
            <h2 class="text-2xl font-semibold mb-4">Инструкция по работе с PR-ассистентом</h2>
            
            <div class="space-y-4 text-gray-700 text-sm leading-relaxed">
              
              <!-- Важное примечание о минимальных требованиях -->
              <div class="p-4 bg-blue-100 border-l-4 border-blue-500">
                <strong>Внимание!</strong>
                <p>Для получения рекомендаций от AI-ассистента необходимо заполнить все основные поля: заголовок, лид и основной текст с минимальным количеством символов.
                  Максимальное количество символов не ограничено, но желательно не выходить за рекомендованное число знаков. Ассистент обрабатывает только пресс-релизы, относящиеся к сфере занятости.</p>
              </div>

              <!-- Основные инструкции -->
              <div>
                <strong>Рекоменуемый объем:</strong>
                <ul class="list-disc pl-6">
                  
                  <li><strong>Заголовок</strong>: до 110 знаков с пробелами</li>
                  <li><strong>Лид</strong>: до 400 знаков с пробелами</li>
                  <li><strong>Основной текст</strong>: до 2000 знаков с пробелами</li>
                </ul>
              </div>          
            </div>

            <!-- Кнопка закрытия -->
            <div class="mt-6 text-right">
              <button @click="showInstructionsModal = false" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500">Закрыть</button>
            </div>
          </div>
        </div>


        <!-- Модальное окно Методические рекомендации -->
        <div v-if="showMetodrecModal" class="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50" @click.self="showMetodrecModal = false">
          <div class="bg-white w-11/12 max-w-3xl p-8 shadow-lg overflow-y-auto max-h-[90vh]">
            <h2 class="text-2xl font-semibold mb-4">Рекомендации</h2>
            
            <div class="space-y-4 text-gray-700 text-sm leading-relaxed">
              <div class="gap-4">
                <strong class="block">Как написать классный пресс-релиз</strong><br/>
                <a href="https://cloud.mail.ru/public/44BX/5Z6mdJuoN" target="_blank" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500">Скачать</a>
              </div>               
              <div class="gap-4">
                <strong class="block">Методрекомендации по подготовке пресс-релизов</strong><br/>
                <a href="https://cloud.mail.ru/public/Q8yc/wLmV7Pkkz" target="_blank" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500">Скачать</a>
              </div>          
              

              

            <!-- Кнопка закрытия -->
            <div class="mt-6 text-right">
              <button @click="showMetodrecModal = false" class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-500">Закрыть</button>
            </div>
          </div>
          </div>
        </div>

        <!-- Блок рекомендаций -->
        <div
          v-if="isLoading || (recommendations && recommendations.length > 0)"
          class="transition-all duration-500 ease-in-out w-full md:w-1/2 opacity-100 mt-4 md:mt-0"
        >
          <div v-if="isLoading" class="space-y-4">
            <div class="animate-pulse" style="animation-delay: 0.2s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse mt-4" style="animation-delay: 0.4s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse" style="animation-delay: 0.6s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse mt-4" style="animation-delay: 0.8s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse" style="animation-delay: 1.0s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse mt-4" style="animation-delay: 1.2s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse" style="animation-delay: 1.4s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
            <div class="animate-pulse mt-4" style="animation-delay: 1.6s">
              <div class="h-6 bg-gray-300 rounded w-3/4 mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-full mb-2"></div>
              <div class="h-4 bg-gray-300 rounded w-5/6"></div>
            </div>
          </div>

          <!-- Отображение рекомендаций после загрузки -->
          <div
            v-else
            v-for="(rec, index) in visibleRecommendations"
            :key="index"
            class="recommendation fade-in-slide"
            :style="{ animationDelay: `${index * 0.3}s` }"
          >
            <h3 class="text-xl font-semibold mb-2">{{ rec.section }}</h3>
            <div v-if="rec.content" v-html="rec.content"></div>
            <p v-else class="italic text-gray-500">Нет рекомендаций для этой секции</p>
          </div>
        </div>
      </div>
    </main>
    <footer class="container mx-auto flex items-center justify-between px-8 py-4">
      <p class="text-gray-600 text-center text-sm py-4">© Федеральный центр компетенций в сфере занятости ВНИИ труда Минтруда России</p>
      <a  class="text-[#0033a0] text-xs font-bold uppercase hover:opacity-75" href="https://cznnew.ru/">Вернуться на сайт</a>
    </footer>
  </div>
</template>


<script>
import axios from "axios";
import markdownIt from 'markdown-it';

export default {
  data() {
    return {
      title: "",
      lead: "",
      body: "",
      recommendations: [],
      visibleSections: [], // Добавлено для управления анимацией
      isLoading: false,
      errors: {},
      formSubmitted: false,
      showModal: false,
      showInstructionsModal: false,
      showMetodrecModal: false,
      md: markdownIt(), 
    };
  },
  computed: {
    isFormValid() {
      // Проверка минимальной длины для каждого из полей
      return (
        this.title.length >= 20 &&
        this.lead.length >= 20 &&
        this.body.length >= 100
      );
    },
    formCompletionPercentage() {
      const titlePercentage = Math.min((this.title.length / 20) * 100, 100);
      const leadPercentage = Math.min((this.lead.length / 20) * 100, 100);
      const bodyPercentage = Math.min((this.body.length / 100) * 100, 100);
      
      // Среднее значение процента для всех полей
      const totalPercentage = (titlePercentage + leadPercentage + bodyPercentage) / 3;
      
      return Math.round(totalPercentage); // Округляем до целого числа
    },
    visibleRecommendations() {
      // Возвращаем только те рекомендации, которые нужно отобразить
      return this.recommendations.filter((_, index) => this.visibleSections.includes(index));
    }
  },
  methods: {
    getCounterColor(length, min, max) {
      if (length < min) return "text-gray-300";
      else if (length <= max) return "text-green-500";
      else return "text-red-500";
    },
    getCounterColorWithOpacity(length, min, max, opacity) {
      if (length < min) return `rgba(207, 214, 228, ${opacity})`; // Серый цвет для минимального
      else if (length <= max) return `rgba(34, 197, 94, ${opacity})`; // Зеленый цвет в диапазоне
      else return `rgba(239, 68, 68, ${opacity})`; // Красный цвет при превышении
    },
    autoResize(event) {
      const textarea = event.target;
      textarea.style.height = 'auto';
      textarea.style.height = `${textarea.scrollHeight}px`;
    },
    handleInput(event, field) {
      // Просто обновляем значение без ограничения по длине
      this[field] = event.target.value;
      this.errors = [];
      // Автоматическое изменение размера поля
      event.target.style.height = 'auto';
      event.target.style.height = `${event.target.scrollHeight}px`;
    },
    async showResult() {
      this.errors = {};
      this.formSubmitted = true;
      this.recommendations = [];
      this.visibleSections = []; // Сброс видимых секций перед новым запросом
      if (!this.validateForm()) {
        return;
      }
      this.isLoading = true;
      try {
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/analyze/`, {
          title: this.title,
          lead: this.lead,
          body: this.body,
        });

        // Создаем новый экземпляр markdownIt
        const markdown = new markdownIt();
        
        this.recommendations = response.data.recommendations.map(rec => ({
          section: rec.section,
          content: markdown.render(rec.content).replace(/\*\*/g, ""), // удаляем оставшиеся `**`
        }));
        console.log("Recommendations:", this.recommendations); // Проверка данных
        this.animateRecommendations(); // Запускаем анимацию для секций
      } catch (error) {
        console.error("Ошибка при анализе:", error);
      } finally {
        this.isLoading = false;
      }
    },
    animateRecommendations() {
      // Плавное появление каждой секции с задержкой
      this.recommendations.forEach((_, index) => {
        setTimeout(() => {
          this.visibleSections.push(index);
        }, index * 400); // Задержка мс между секциями
      });
    },
    parseRecommendations(recommendationsText) {
      const sections = recommendationsText.split(/\n\n(?=\d+\.\s)/); // Разбиваем по номерам с точками
      return sections.map((section) => {
        const match = section.match(/^\d+\.\s\*\*(.+?)\*\*:\s*(.*)$/s);
        if (match) {
          return {
            section: match[1],
            content: match[2].replace(/\n/g, " "), // Объединяем строки для лучшего отображения
          };
        } else {
          return { section: "Общая рекомендация", content: section };
        }
      });
    },
    validateForm() {
      this.errors = {};
      if (!this.title || this.title.length < 20) {
        this.errors.title = "Слишком короткий заголовок";
      }
      if (!this.lead || this.lead.length < 20) {
        this.errors.lead = "Слишком короткий лид";
      }
      if (!this.body || this.body.length < 100) {
        this.errors.body = "Минимум 100 символов для основного текста";
      }
      return Object.keys(this.errors).length === 0;
    },
  },
};
</script>

<style>
.container {
  max-width: 1400px;
}

/* Flex column layout on smaller screens */
@media (max-width: 768px) {
  .container {
    flex-direction: column;
  }
  .recommendations {
    margin-top: 20px;
    width: 100%;
  }
}

textarea {
  overflow-y: hidden;
  resize: none;
}

.prose {
  max-width: 100%;
}
.text-red-500 { color: #f56565; }
.text-yellow-500 { color: #ecc94b; }
.text-green-500 { color: #48bb78; }
.container {
  max-width: 1200px;
}
.custom-scrollbar::-webkit-scrollbar { width: 8px; }
.custom-scrollbar::-webkit-scrollbar-track { background: #f0f0f0; border-radius: 10px; }
.custom-scrollbar::-webkit-scrollbar-thumb { background-color: #3182ce; border-radius: 10px; border: 2px solid #f0f0f0; }
.custom-scrollbar::-webkit-scrollbar-thumb:hover { background-color: #2b6cb0; }
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: #3182ce #f0f0f0;
}


/* Основные стили блока рекомендации */
.recommendation {
  background-color: #f9fafb;
  padding: 1rem;
  border-left: 4px solid #3182ce;
  margin-bottom: 1rem;
  opacity: 0;
  transform: translateX(-30px);
  animation: fadeInSlide 0.6s ease forwards;
}

/* Анимация появления слева */
@keyframes fadeInSlide {
  0% {
    opacity: 0;
    transform: translateX(-30px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}


.loading-spinner {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-spinner::before,
.loading-spinner::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid transparent;
  border-top-color: white; /* Цвет лепестков */
  animation: spin .5s linear infinite;
}

.loading-spinner::after {
  animation-delay: 0.25s; /* Сдвиг для второго круга */
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes bounceOnce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  0% {
    transform: translateY(-5px);
  }
}

.animate-bounce-once {
  animation: bounceOnce 0.5s ease-in;
}

.animated-header {
  /* Базовые настройки градиента */
  background: radial-gradient(90deg, #0033A0, #001134);
  background-size: 100% 100%;
  animation: gradientAnimation 10s ease-in-out infinite;
}

@keyframes gradientAnimation {
  0% {
    background-position: 0% 50%;
    background-color: #0033A0;
  }
  50% {
    background-position: 100% 100%;
    background-color: #001F5F;
  }
  100% {
    background-position: 0% 0%;
    background-color: #0033A0;
  }
}
</style>
